import { Directive, ElementRef, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneFormat]',
  standalone: false,
})
export class PhoneFormatDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Self() private ngControl: NgControl,
  ) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const digits = value.replace(/\D/g, '').slice(0, 10);
    const formatted = this.format(digits);
    this.el.nativeElement.value = formatted;
    this.ngControl.control?.setValue(formatted, { emitEvent: false });
  }

  private format(digits: string): string {
    if (digits.length > 6) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    if (digits.length > 3) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return digits;
  }
}
